import { Select } from 'antd';
import { notify } from 'components/Notify/Notify';

import { BUSINESS_SIZE_OPTIONS } from 'constants/Businesses';
import { updateBusinessSize } from 'services/business';

import './BusinessSizeSelector.less';

const BusinessSizeSelector = ({
  businessSize,
  _id: businessId,
  setFetchedData,
  refreshData,
  setContainerLoading
}) => {
  const onSizeChange = async (value) => {
    try {
      setContainerLoading(true);
      setFetchedData((prev) => ({
        ...prev,
        businessData: { ...prev.businessData, businessSize: value }
      }));
      await updateBusinessSize(businessId, { size: value });
      refreshData();
    } catch (error) {
      notify(error.message);
      setContainerLoading(false);
    }
  };

  return (
    <Select
      className="br-business-size__selector"
      options={BUSINESS_SIZE_OPTIONS}
      value={businessSize}
      onChange={onSizeChange}
    />
  );
};

export default BusinessSizeSelector;
